import { ColumnService, LevelService, RackService } from '@gtpl/shared-services/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { locationsAdapter } from './dto/location-adapter';
import { LocationsRepository } from './dto/location-repository';
import { LocationsController } from './locations.controller';
import { LocationsService } from './locations.service';
import { Sample } from './sample.entity';

@Module({

  imports: [
    TypeOrmModule.forFeature([LocationsRepository,Sample]),
  ],
  controllers: [LocationsController],
  providers: [LocationsService,locationsAdapter,ApplicationExceptionHandler,RackService,ColumnService,LevelService]
})
export class LocationsModule {

}
